
class Franchise {
	constructor(request) {
		this.request = request
		this.endpoint = 'franchise'
	}
	
	Search(category, fail ) {
		return this.request.requestData(`https://cdn.ngnw.ph/lists/${this.endpoint}/category/${category}.json`)
	}
	
	SearchTop(category) {
		return this.request.requestData(`https://cdn.ngnw.ph/lists/${this.endpoint}/category/top/${category}.json`)
	}
	
	SearchText(text) {
		const body = {
			"searchtext":text
		}
		return this.request.send(
			`${this.endpoint}/search/`,
			'POST',
			body
		)
	}

	SearchOrganizationProduct(id) {
		return this.request.requestData(`https://cdn.ngnw.ph/lists/${this.endpoint}/organization/${id}.json`)
	}

	SearchMultiple(query) {
		const body = {
			query
		}
		return this.request.send(
			`${this.endpoint}/search/`,
			'POST',
			body
		)
	}
	
	Apply(info) {
		return this.request.send(
			`${this.endpoint}/request`,
			'POST',
			info,
			undefined,
			undefined, 
			{
				"configkey":"90251892a0c2878c3b88c08a79a3d903"
			}
		)
	}

	GetDetails(url) {
		return this.request.requestData(
			`https://cdn.ngnw.ph/details/${this.endpoint}/${url}.json`
		)
	}

	GetDetailsQuestions(url) {
		return this.request.requestData(
			`https://cdn.ngnw.ph/details/${this.endpoint}/apply/${url}.json`
		)
	}
}


export default Franchise